// antd 组件内置文字（日期面板、分页、确认按钮等）随界面语言切换
import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import zhTW from 'antd/locale/zh_TW';
import { useTranslation } from 'react-i18next';

const ANTD_LOCALE = { 'zh-CN': zhCN, en: enUS, 'zh-TW': zhTW };

const AntdLocale = ({ children }) => {
  const { i18n } = useTranslation();
  return <ConfigProvider locale={ANTD_LOCALE[i18n.language] || zhCN}>{children}</ConfigProvider>;
};

export default AntdLocale;
